module.exports = __webpack_public_path__ + "media/images/tigor/tigor5-0f6400b3178cf184f6536e5ecfca71ab.png";